import { Injectable } from '@angular/core'
import { Action, select, Store } from '@ngrx/store'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'

import * as TableNumbersSelectors from './table-numbers.selectors'

@Injectable({ providedIn: 'root' })
export class TableNumbersFacade implements GbBaseFacade {
  loaded$ = this.store.pipe(select(TableNumbersSelectors.getTableNumbersLoaded))
  allTableNumbers$ = this.store.pipe(select(TableNumbersSelectors.getAllTableNumbers))
  getTableById$ = (id: string) => this.store.select(TableNumbersSelectors.getTableById(id))

  constructor(private readonly store: Store) {}

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
